exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-c97696d8]{position:relative;display:inline-block;vertical-align:middle}.dropdown select[data-v-c97696d8]{background-color:#df6326;color:#fff;padding:.5em;padding-right:2.5em;border:0;margin:0;text-indent:.01px;text-overflow:\"\";-webkit-appearance:button}", ""]);

// exports
